import React from "react";
import { Box, Typography, Container, Grid, Link, Divider } from "@mui/material";
import { School, Email, Phone, LocationOn } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#1565C0",
        color: "white",
        py: 6,
        mt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* University Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <School sx={{ mr: 2, fontSize: 32 }} />
              <Box>
                <Typography variant="h6" fontWeight="bold">
                  มหาวิทยาลัยเทคโนโลยีนวัตกรรม
                </Typography>
                <Typography variant="caption">
                  Innovation Technology University
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.9, lineHeight: 1.6 }}>
              สถาบันการศึกษาชั้นนำที่มุ่งเน้นการพัฒนานวัตกรรม
              และเทคโนโลยีเพื่ออนาคตที่ยั่งยืน
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              ลิงก์ด่วน
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="/dashboard"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9, "&:hover": { opacity: 1 } }}
              >
                หน้าแรก
              </Link>
              <Link
                href="/courses"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9, "&:hover": { opacity: 1 } }}
              >
                หลักสูตรเรียน
              </Link>
              <Link
                href="/login"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9, "&:hover": { opacity: 1 } }}
              >
                เข้าสู่ระบบ
              </Link>
              <Link
                href="#"
                color="inherit"
                underline="hover"
                sx={{ opacity: 0.9, "&:hover": { opacity: 1 } }}
              >
                เกี่ยวกับเรา
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              ติดต่อเรา
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", opacity: 0.9 }}>
                <Email sx={{ mr: 1, fontSize: 20 }} />
                <Typography variant="body2">info@itu.ac.th</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", opacity: 0.9 }}>
                <Phone sx={{ mr: 1, fontSize: 20 }} />
                <Typography variant="body2">02-XXX-XXXX</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", opacity: 0.9 }}>
                <LocationOn sx={{ mr: 1, fontSize: 20 }} />
                <Typography variant="body2">กรุงเทพมหานคร ประเทศไทย</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.2)" }} />

        <Box sx={{ textAlign: "center" }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © 2025 มหาวิทยาลัยเทคโนโลยีนวัตกรรม สงวนลิขสิทธิ์
          </Typography>
          <Typography
            variant="caption"
            sx={{ opacity: 0.6, mt: 1, display: "block" }}
          >
            Innovation Technology University. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
